const lang = {
  "list.workspace": "我的工作区",
  "list.workspace.li1": "全部内容",
  "list.workspace.li2": "案例",
  "list.workspace.li3": "文档",
  "list.workspace.li4": "图像可视化",

  "content.document": "文档",
  "content.graph": "图像",
  "content.item": "文件",
  "content.case": "案例",
  "content.data-source": "数据源",
  "content.last-save": "保存于",
  "content.blank": "此处无可显示内容",
  "content.tag": "标签",
  "content.note": "注释",

  account: "账户",
  "account.account-setting": "账户设置",
  "account.lang": "语言",
  "account.contact-us": "联系我们",
  "account.logout": "退出登陆",

  "edit.view": "视图",
  "edit.refresh": "刷新",
  "edit.select": "选择",
  "edit.delete": "删除",
  "edit.selected": "已选择",
  "edit.moveout": "移出",
  "edit.cancel": "取消",
  "edit.download": "下载",
  "edit.moveto": "移动至",

  "action.rename": "重命名",
  "action.delete": "删除",
  "action.moveout": "移出此案例",
  "action.moveto": "移动至案例",
  "action.view-note": "查看注释",
  "action.view-tag": "查看标签",
  "action.create-newcase": "创建案例",

  "list.name": "名称",
  "list.last-modified": "最近修改时间",
  "list.stock-code": "股票代码",
  "list.document-issuer": "发布者",
  "list.data-source": "数据源",

  "tag.less": "显示较少",
  "tag.more": "显示全部",

  "dialog.confirm": `确认要从工作区中删除?此操作不可逆.`,
  "dialog.ok": "确认",
  "dialog.cancel": "取消",
  "dialog.delete": "删除",
  "dialog.newcase": "新案例",
  "dialog.action-confirm": "请确认您的操作",
  "dialog.casename": "案例名称",
  "dialog.selected-items": "已选择文件",
  "dialog.rename-case": "重命名",

  loading: "加载中...",

  "toast.success": "操作成功",
  "toast.error": "出错了",
  "toast.pending": "进行中...",
  "toast.warning": "请等待上一个进程完成",

  "dialog.tip1": "",
  "dialog.tip2": "*请输入至多32个字符",
  "dialog.tip3": "*此案例名已存在",

  popover: "文档包含在以下案例中："
};
export default lang;



//////////////////
// WEBPACK FOOTER
// ./static/lang/cns.js
// module id = null
// module chunks = 